export default __webpack_public_path__ + "static/media/rickrollmp3.5443f889.mp3";